<template>
  <BaseLayout page-default-back-link="/nativeTab/news" :pageTitle="textData.title">
    <ion-content class="certification-uploadDocuments">
      <!-- <div>token:{{store.getters['user/token']}}</div> -->
      <div class="label p-l-20 p-r-20 p-b-30 p-t-30">请仔细查看下方您的信息是否正确，并上传正确的认证资料确保您的认证成功。</div>
      <div class="card f-1">
        <div
          v-for="(item, index) in keysData"
          class="pc-input-box"
          :class="[
              {'hidden m-b-0' : item.isHide },
              {'pc-input-is-error' : requiredErrorKey === item.key},
              {'pc-input-is-required' : !form[item.key] && item.isRequired},
              {'m-b-50': keysData.length - 1 == index}
          ]"
          :key="index"
        >
          <input
            v-if="item.type == 'text'"
            class="is-required pc-input"
            :ref="el => nodes[item.key].value = el"
            v-model="form[item.key]"
            @blur="onBlur"
            :placeholder="item.label"
          />
        </div>
      </div>
      <div v-if="userType == 'enterprise'" class="f-column">
        <div :id="baseImageKeys[0]" class="title p-30 white-bg border-t border">1. 上传企业营业执照副本</div>
        <div class="f-center f-column">
          <Camera
            type="field"
            :fieldId="imageFormId[baseImageKeys[0]]"
            :image="imageFormUrl[baseImageKeys[0] + 'Url']"
            :bgImage="enterpriseImage"
            bgImageClass="enterprise-image"
            class="m-t-50 m-b-50"
            @onCaptured="(v) => onCaptured(baseImageKeys[0], v)"
          />
        </div>
      </div>

      <div v-if="userType == 'lawyer'" class="f-column">
        <div :id="baseImageKeys[0]" class="title p-30 white-bg border-t border">1. 上传律师执业证登记信息和照片页</div>
        <div class="f-center f-column">
          <Camera
            type="field"
            :fieldId="imageFormId[baseImageKeys[0]]"
            :image="imageFormUrl[baseImageKeys[0] + 'Url']"
            bgImageClass="enterprise-image"
            class="m-t-50 m-b-50"
            @onCaptured="(v) => onCaptured(baseImageKeys[0], v)"
          />
        </div>
        <div :id="baseImageKeys[1]" class="title p-30 white-bg border-t border">2. 上传律师执业证年检页</div>
        <div class="f-center f-column">
          <Camera
            type="field"
            :fieldId="imageFormId[baseImageKeys[1]]"
            :image="imageFormUrl[baseImageKeys[1] + 'Url']"
            bgImageClass="enterprise-image"
            class="m-t-50 m-b-50"
            @onCaptured="(v) => onCaptured(baseImageKeys[1], v)"
          />
        </div>
      </div>
      <div v-if="userType == 'lawOffice'" class="f-column">
        <div :id="baseImageKeys[0]" class="title p-30 white-bg border-t border">1. 上传律所执业许可证副本页</div>
        <div class="f-center f-column">
          <Camera
            type="field"
            :fieldId="imageFormId[baseImageKeys[0]]"
            :image="imageFormUrl[baseImageKeys[0] + 'Url']"
            :bgImage="lawOffice1Image"
            bgImageClass="lawOffice-image"
            class="m-t-50 m-b-50"
            @onCaptured="(v) => onCaptured(baseImageKeys[0], v)"
          />
        </div>
        <div :id="baseImageKeys[1]" class="title p-30 white-bg border-t border">2. 上传律所执业许可证副本登记页</div>
        <div class="f-center f-column">
          <Camera
            type="field"
            :fieldId="imageFormId[baseImageKeys[1]]"
            :image="imageFormUrl[baseImageKeys[1] + 'Url']"
            :bgImage="lawOffice2Image"
            bgImageClass="lawOffice-image"
            class="m-t-50 m-b-50"
            @onCaptured="(v) => onCaptured(baseImageKeys[1], v)"
          />
        </div>
        <div :id="baseImageKeys[2]" class="title p-30 white-bg border-t border">3. 上传律所执业许可证副本年检页</div>
        <div class="f-center f-column">
          <Camera
            type="field"
            :fieldId="imageFormId[baseImageKeys[2]]"
            :image="imageFormUrl[baseImageKeys[2] + 'Url']"
            :bgImage="lawOffice3Image"
            bgImageClass="lawOffice-image"
            class="m-t-50 m-b-50"
            @onCaptured="(v) => onCaptured(baseImageKeys[2], v)"
          />
        </div>
      </div>

      <IDCard
        type="field"
        :idCardBackUrl="imageFormUrl[IDCardImageKeys[0] + 'Url']"
        :idCardPositiveUrl="imageFormUrl[IDCardImageKeys[1] + 'Url']"
        :idCardUserUrl="imageFormUrl[IDCardImageKeys[2] + 'Url']"
        :idCardBackKey="IDCardImageKeys[0]"
        :idCardPositiveKey="IDCardImageKeys[1]"
        :idCardUserKey="IDCardImageKeys[2]"
        :idCardBackFieldId="imageFormId[IDCardImageKeys[0]]"
        :idCardPositiveFieldId="imageFormId[IDCardImageKeys[1]]"
        :idCardUserFieldId="imageFormId[IDCardImageKeys[2]]"
        :titleOne="textData.IDCardTitles[0]"
        :titleTow="textData.IDCardTitles[1]"
        @onCaptured="({ key, value }) => onCaptured(key, value)"
      />
      <div class="m-b-100 m-l-75 m-r-75">
        <ion-button expand="block" @click="onSubmit">提交</ion-button>
      </div>
    </ion-content>
  </BaseLayout>
</template>

<script>
import router from '@/router'
import { ref, reactive, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import { IDCard } from '@/view/certification/components'
import { useRoute } from 'vue-router'
import { Camera } from '@/view/certification/components'
import { toastController } from '@ionic/vue'
import { formApi, certificationApi } from '@/apis'
import formData from '@/view/certification/formData'
import { loadingCreate } from '@/utils/alert'
import enterpriseImage from '@/view/certification/assets/enterprise.png'
import lawOffice1Image from '@/view/certification/assets/lawOffice-1.png'
import lawOffice2Image from '@/view/certification/assets/lawOffice-2.png'
import lawOffice3Image from '@/view/certification/assets/lawOffice-3.png'

export default {
  setup() {
    const route = new useRoute()
    const store = new useStore()

    const userType = route.query.userType || 'individual'
    const textDatas = {
      individual: {
        title: '个人认证',
        prompt: '请根据下方提示上传个人实名认证所需要的资料',
        IDCardTitles: ['1. 上传身份证图片', '2. 上传手持身份证人像面图片'],
      },
      enterprise: {
        title: '企业认证',
        prompt: '请根据下方提示上传认证企业所需要的资料',
        IDCardTitles: [
          '2. 上传法定代表人身份证正反面照片',
          '3. 上传法定代表人手持身份证人像面图片',
        ],
      },
      lawyer: {
        title: '律师认证',
        prompt: '请根据下方提示上传认证律师所需要的资料',
        IDCardTitles: [
          '3. 上传律师身份证正反面照片',
          '4. 上传律师手持身份证人像面图片',
        ],
      },
      lawOffice: {
        title: '律师主任认证',
        prompt: '请根据下方提示上传认证律所需要的资料',
        IDCardTitles: [
          '4. 上传律所负责人身份证正反面照片',
          '5. 上传律所负责人手持身份证人像面图片',
        ],
      },
    }
    const textData = reactive(textDatas[userType])
    console.log('userType', userType)
    document.getElementsByTagName('title')[0].innerText = textData.title

    let formDetails = {}
    const baseImageKeysDict = {
      enterprise: ['qyyyzzfb'],
      lawyer: ['lszyzdjxxhzpy', 'lszyznjy'],
      lawOffice: ['lszyxkzfby', 'lszyxkzfbdjy', 'lszyxkzfbnjy'],
    }
    const IDCardImageKeysDict = {
      enterprise: ['fddbrsfzzmzp', 'fddbrsfzfmzp', 'fddbrscsfzzmtp'],
      lawyer: ['lvsfzzmz', 'lssfzfmz', 'lvscsfzzmzp'],
      lawOffice: ['lsfzrsfzzmzp', 'lsfzrsfzfmzp', 'lsfzrscsfzzmzp'],
    }

    const otherKeysDict = {
      enterprise: ['rzzt', 'xqsm', 'zzid'],
      lawyer: ['rzzt', 'xqsm', 'userId'],
      lawOffice: ['rzzt', 'xqsm', 'zzid'],
    }

    const keysData = formData[userType]
    const mData = keysData.reduce((o, item) => {
      return { ...o, [item.key]: '' }
    }, {})

    const nodes = keysData.reduce((o, item) => {
      return { ...o, [item.key]: ref(null) }
    }, {})

    const form = reactive(mData)

    const requiredErrorKey = ref('')

    const onBlur = () => {
      requiredErrorKey.value = ''
    }

    const baseImageKeys = baseImageKeysDict[userType]
    const IDCardImageKeys = IDCardImageKeysDict[userType]
    const otherKeys = otherKeysDict[userType]

    const imageForm = reactive(
      [...baseImageKeys, ...IDCardImageKeys, ...otherKeys].reduce((o, key) => {
        if (key === 'zzid') {
          return { ...o, [key]: route.query.id }
        } else {
          return { ...o, [key]: '' }
        }
      }, {})
    )

    const imageFormUrl = reactive(
      [...baseImageKeys, ...IDCardImageKeys].reduce((o, key) => {
        return { ...o, [`${key}Url`]: '' }
      }, {})
    )

    const imageFormId = reactive(
      [...baseImageKeys, ...IDCardImageKeys].reduce((o, key) => {
        return { ...o, [`${key}`]: '' }
      }, {})
    )

    const uploadToast = async (key) => {
      console.log('key', key)
      const item = formDetails.fieldList.find(({ fieldEn }) => fieldEn == key)
      console.log('imageForm', imageForm, item)
      const toast = await toastController.create({
        message: `请上传${item.fieldName}`,
        position: 'top',
        translucent: true,
        duration: 3000,
      })
      return toast.present()
    }

    const onCaptured = (key, imageFile) => {
      imageForm[key] = imageFile.id
      console.log('imageFile', imageFile)
    }

    const onSubmit = async () => {
      const checkImage = [...baseImageKeys, ...IDCardImageKeys]
      const errImageKey = checkImage.find((key) => imageForm[key] == '')
      if (errImageKey) {
        uploadToast(errImageKey)
        document.getElementById(errImageKey).scrollIntoView()
        return
      }

      console.log('imageForm', imageForm)
      const idDict = {
        enterprise: 3,
        lawyer: 2,
        lawOffice: 1,
      }
      const appendBody = {
        enterprise: {},
        lawyer: {},
        lawOffice: {},
      }
      const formId = idDict[userType]

      const inputDataAjaxs = {
        lawyer: certificationApi.lawyerInputData,
        lawOffice: certificationApi.lawOfficeInputData,
        enterprise: certificationApi.enterpriseInputData,
      }
      console.log('form', { ...form })

      const loading = await loadingCreate('资料提交中...')
      try {
        const data = await inputDataAjaxs[userType](form)
        if (userType == 'enterprise') {
          appendBody.zzid = data.id
        }
        console.log('appendBody', { formId, ...imageForm, ...appendBody })
        await formApi.update({ formId, ...imageForm, ...appendBody })
        router.replace('/certification/fulfill')
      } finally {
        loading.dismiss()
      }
    }

    const getData = async () => {
      const loading = await loadingCreate('数据获取中...')
      try {
        const idDict = {
          enterprise: 3,
          lawyer: 2,
          lawOffice: 1,
        }
        const id = idDict[userType]
        const ajaxs = {
          lawOffice: async () =>
            await certificationApi.lawOfficeAuthOrg({ formId: 1 }),
          lawyer: async () => await certificationApi.lawyerAuthOrg(),
          enterprise: async () =>
            await certificationApi.lawOfficeAuthOrg({ formId: 3 }),
        }
        formDetails = await formApi.details({ id })
        // lawyerAuthOrg
        formDetails.fieldList.forEach((item) => {
          imageFormId[item.fieldEn] = item.id
        })
        console.log('formDetails', formDetails.fieldList)
        const info = await ajaxs[userType]()
        const infoKeys = Object.keys(info)
        infoKeys.forEach((key) => {
          if (form.hasOwnProperty(key) || key == 'id') {
            form[key] = info[key]
          }
          if (imageForm.hasOwnProperty(key)) {
            imageForm[key] = info[key]
          }
          if (imageFormUrl.hasOwnProperty(key)) {
            imageFormUrl[key] = info[key]
          }
        })
      } finally {
        loading.dismiss()
      }
    }
    onBeforeMount(async () => {
      getData()
    })
    return {
      store,
      form,
      nodes,
      keysData,
      requiredErrorKey,
      onBlur,
      textData,
      onSubmit,
      onCaptured,
      imageFormUrl,
      imageFormId,
      userType,
      baseImageKeys,
      IDCardImageKeys,
      enterpriseImage,
      lawOffice1Image,
      lawOffice2Image,
      lawOffice3Image,
    }
  },
  components: { IDCard, Camera },
}
</script>

<style lang="scss">
@import 'style.scss';

.certification-uploadDocuments {
  .card {
    padding: 40px 75px 1px;
    background-color: #fff;
  }
  .toast-wrapper {
    --background: red;
    // --background: rgba(0,0,0, .7);
  }
  ion-content {
    --background: #f5f5f5;
  }
  .card {
    padding: 40px 75px 75px;
  }
  .title {
    font-size: 32px;
    font-weight: bold;
    color: #333333;
  }
  .id-title {
    font-size: 32px;
    color: #333333;
  }
  .label {
    font-size: 28px;
    color: #666666;
  }
}
</style>